{
    "coordinates": [
        52.2353170879862,
        7.960040042919843
    ],
    "tooltip": "Kupferschiefer",
    "title": "Kupferschiefer",
    "country": "Germany",
    "period": "Permian"
}
